module.exports = __webpack_public_path__ + "static/media/DeleteRed.67f10b55.svg";